export class RedirectResponse {
    constructor(status: number, message: string, redirectUrl: string) {
        this.status = status;
        this.message = message;
        this.redirectUrl = redirectUrl;
    }

    status: number;
    message: string;
    redirectUrl: string;
}
